// extracted by mini-css-extract-plugin
export default {"baseStyles":"VhU0t"};